import React, { useState } from "react";

import GoBack from "../../../../components/go-back";
import Table from "../../../../components/table-simple/table";
import Pagination from "../../../../components/pagination";
import NoData from "../no-data";
import SelectBox from "../../../../components/select-box/select-box";
import LoaderSpinner from "../../../../components/loader-spinner";
import { RequestsContainer, SectionContainer } from "./requests-style";

import useGetRequests from "./useGetRequests";
import { getRelatedMediatorsCodes } from "../../../../utils/mediatorCode";
import { RequestsProps } from "./requests-types";
import { MediatorCodesInputType } from "../../clients-dashboard/clients-dashboard-types";

const CompletedRequests = ({ mediator }: RequestsProps) => {
  const [mediatorCode, setMediatorCode] = useState<string>(mediator.mediatorCode);

  const mediatorCodesInput: MediatorCodesInputType = {
    codeOptions: getRelatedMediatorsCodes(mediator),
    selectedCode: mediatorCode,
  };

  const { pagination, setPagination, isLoading, data, error } = useGetRequests({
    mediatorCode,
    isPending: false,
  });

  return (
    <RequestsContainer>
      <div className="black-arrow-container">
        <GoBack text="Volver" />
      </div>

      <div className="main-title-container">
        <h2>SOLICITUDES FINALIZADAS</h2>
      </div>

      <SectionContainer>
        {mediatorCodesInput.codeOptions.length > 1 ? (
          <div className="mediators">
            <div className="selectBox">
              <SelectBox
                isMediator
                optionsText={mediatorCodesInput.codeOptions}
                optionKey="value"
                optionValue="label"
                defaultValue={mediatorCode}
                initialValue={mediatorCodesInput.selectedCode}
                propValue={mediatorCodesInput.selectedCode}
                disabled={mediatorCodesInput.codeOptions.length < 2}
                required
                onChange={(value: string) => setMediatorCode(value)}
              />
              <label>Mediador</label>
            </div>
          </div>
        ) : null}
        {isLoading && (
          <div className="spinner">
            <LoaderSpinner />
          </div>
        )}
        {!isLoading && data && (
          <>
            <Table columns={data.columns} data={data.data} />
            <div className="requests-pagination">
              <Pagination
                page={pagination.page}
                limit={pagination.totalPages}
                callback={(newPage: number) => setPagination({ ...pagination, page: newPage })}
              />
            </div>
          </>
        )}
        {error && <NoData message={error} />}
      </SectionContainer>
    </RequestsContainer>
  );
};

export default CompletedRequests;
